import hipaaImage from "assets/images/hipaa.svg";
import { useLoading } from "context/LoadingContext";
import { Outlet, useMatch } from "react-router-dom";

import { Loading } from "../Loading";
import { Navbar } from "../Navbar";
import {
  ContentContainer,
  FooterNote,
  ImageContainer,
  StyledImage,
} from "./styled";

export function PublicLayout() {
  const { isLoading } = useLoading();
  // The patient checkout (/order/:id) shows the footer as a text line; every other public page keeps the logos.
  const checkoutMatch = useMatch("/order/:id");
  const isCheckout =
    !!checkoutMatch && checkoutMatch.params.id !== "direct-pay";

  return (
    <div className="flex flex-column w-full h-full justify-content-between">
      <Navbar variant="unlogged" />
      <ContentContainer className="flex flex-column mt-8 align-items-center">
        {isLoading && <Loading />}
        <Outlet />
      </ContentContainer>
      {isCheckout ? (
        <FooterNote className="text-center text-sm line-height-3 py-4 mt-3">
          <span>Powered by Clear Health</span> · HIPAA Compliant &amp; Secure
        </FooterNote>
      ) : (
        <ImageContainer className="flex align-items-center gap-3 bottom-0 p-3 mt-3 bg-white">
          <div className="text-center">
            <StyledImage src="/logo_footer_gray.png" alt="Clear Health Logo" />
          </div>
          <StyledImage src={hipaaImage as string} alt="Hipaa Compliant" />
        </ImageContainer>
      )}
    </div>
  );
}
